// import axios from "axios";

// const API_BASE_URL =
//   import.meta.env.VITE_API_URL || "http://localhost:5000/api";

// // Create axios instance
// const api = axios.create({
//   baseURL: API_BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// // Request interceptor to add the auth token to every secure request
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response interceptor for handling universal errors, like an expired session
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       // If the token is invalid or expired, log the user out automatically
//       localStorage.removeItem("token");
//       window.location.href = "/login";
//     }
//     return Promise.reject(error);
//   }
// );

// // --- API method definitions ---
// // These are all correctly defined. No changes are needed here.

// export const authAPI = {
//   login: (credentials) => api.post("/auth/login", credentials),
//   register: (userData) => api.post("/auth/register", userData),
//   getProfile: () => api.get("/auth/profile"),
//   // This correctly sends multipart/form-data when you include a file
//   updateProfile: (data) =>
//     api.put("/auth/profile", data, {
//       headers: { "Content-Type": "multipart/form-data" },
//     }),
//   updateLocation: (location) => api.put("/auth/location", location),
// };

// export const booksAPI = {
//   getAll: (params) => api.get("/books", { params }),
//   getById: (id) => api.get(`/books/${id}`),
//   getAllBooks: () => api.get("/books"),
//   // This is correctly configured for file uploads.
//   // It will correctly receive the new book data if the backend sends it.
//   create: (formData) =>
//     api.post("/books", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     }),
//   update: (id, formData) =>
//     api.put(`/books/${id}`, formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     }),
//   delete: (id) => api.delete(`/books/${id}`),
//   getMyBooks: () => api.get("/books/my-books"),
//   getUserBooks: (userId) => api.get(`/books/user/${userId}`),
// };

// export const borrowAPI = {
//   createRequest: (bookId) => api.post(`/borrow/request/${bookId}`), // Renamed for clarity
//   getMyRequests: () => api.get("/borrow/my-requests"),
//   getReceivedRequests: () => api.get("/borrow/received-requests"),
//   updateRequest: (requestId, status) =>
//     api.put(`/borrow/${requestId}`, { status }),
//   deleteRequest: (requestId) => api.delete(`/borrow/${requestId}`),
//   returnBook: (requestId) => api.put(`/borrow/${requestId}/return`),
// };

// export const usersAPI = {
//   getUsersWithBooks: (params) => api.get("/users/with-books", { params }),
//   getUserLocation: (userId) => api.get(`/users/${userId}/location`),
//   getUserProfile: (userId) => api.get(`/users/${userId}/profile`),
//   searchUsers: (params) => api.get("/users/search", { params }),
//   updatePublicKey: (publicKeyJwk) =>
//     api.put("/users/public-key", { publicKeyJwk }),
// };

// // Friends
// export const friendsAPI = {
//   getAll: () => api.get("/friends"),
//   respond: (id, response) => api.post(`/friends/respond/${id}`, { response }),
//   remove: (id) => api.delete(`/friends/${id}`),
//   // Change this line
//   cancelRequest: (id) => api.delete(`/friends/${id}`), // <-- FIX: Remove '/request' from the URL
// };

// // --- THE NEWLY ADDED API METHODS ---
// export const messagesAPI = {
//   sendMessage: (recipientId, data) => api.post(`/messages/send/${recipientId}`, data),
//   getConversations: () => api.get('/messages/conversations'),
//   getConversationWith: (userId) => api.get(`/messages/with/${userId}`),
//   clearConversation: (conversationId) => api.delete(`/messages/conversation/${conversationId}`),
// };

// // --- REPORT API METHODS ---
// export const reportAPI = {
//   createReport: (reportData) => api.post("/reports", reportData),
//   getMyReports: () => api.get("/reports/my-reports"),
// };

// // --- TESTIMONIAL API METHODS ---
// export const testimonialAPI = {
//   createTestimonial: (testimonialData) =>
//     api.post("/testimonials", testimonialData),
//   getPublishedTestimonials: () => api.get("/testimonials"),
//   getUserTestimonial: () => api.get("/testimonials/my-testimonial"),
//   updateUserTestimonial: (testimonialData) =>
//     api.put("/testimonials/my-testimonial", testimonialData),
//   deleteUserTestimonial: () => api.delete("/testimonials/my-testimonial"),
// };

// export const reviewsAPI = {
//   create: (payload) => api.post("/reviews", payload), // { borrowRequestId, toUserId, rating, comment }
//   listForUser: (userId, params) =>
//     api.get(`/reviews/user/${userId}`, { params }),
//   summaryForUser: (userId) => api.get(`/reviews/user/${userId}/summary`),
// };

// export const notificationsAPI = {
//   getUnreadCount: () => api.get('/users/notifications/unread-count').then(res => res.data),
//   markRead: () => api.put('/users/notifications/mark-read').then(res => res.data),
//   createBookInquiry: ({ toUserId, subject, body }) => api.post('/notifications/book-inquiry', { toUserId, subject, body }),
//   listBookInquiries: (params) => api.get('/notifications/book-inquiry', { params }),
//   delete: (id) => api.delete(`/notifications/${id}`),
// };
//     api.put("/users/notifications/mark-read").then((res) => res.data)

// export default api;

import axios from "axios";

const API_BASE_URL =
  import.meta.env.VITE_API_URL || "http://localhost:5000/api";

// Create axios instance with increased timeout for cold starts
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // 60 second timeout (for Render cold starts)
  headers: {
    "Content-Type": "application/json",
  },
});

// Import session manager
import sessionManager from './sessionManager';

// Request interceptor to add the auth token to every secure request
api.interceptors.request.use(
  (config) => {
    const token = sessionManager.getToken();
    if (token && sessionManager.isTokenValid()) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for handling universal errors, like an expired session
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Handle timeout errors with retry (for cold starts)
    if (error.code === 'ECONNABORTED' && !originalRequest._retry) {
      originalRequest._retry = true;
      originalRequest.timeout = 90000; // 90 seconds for retry
      return api(originalRequest);
    }
    
    // Handle rate limiting (429 errors)
    if (error.response?.status === 429) {
      const retryAfter = error.response.headers['retry-after'] || 60;
      const message = error.response.data?.message || `Too many requests. Please wait ${retryAfter} seconds.`;
      
      // Show user-friendly notification
      if (typeof window !== 'undefined' && window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('rateLimitExceeded', {
          detail: { message, retryAfter }
        }));
      }
      
      console.warn(`Rate limit exceeded. Retry after ${retryAfter} seconds.`);
    }
    
    if (error.response?.status === 401) {
      // Only redirect to login if we're not already on login/register pages
      const currentPath = window.location.pathname;
      const isAuthPage = currentPath === '/login' || 
                        currentPath === '/register' || 
                        currentPath === '/auth/callback' ||
                        currentPath === '/';
      
      sessionManager.removeToken();
      
      if (!isAuthPage) {
        // Store the current path to redirect back after login
        localStorage.setItem('redirectAfterLogin', currentPath);
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// --- API method definitions ---

export const authAPI = {
  login: (credentials) => api.post("/auth/login", credentials),
  register: (userData) => api.post("/auth/register", userData),
  checkUsername: (username, config) => api.get("/auth/check-username", { params: { username }, ...config }),
  checkDisplayName: (name, config) => api.get("/auth/check-name", { params: { name }, ...config }),
  getProfile: () => api.get("/auth/profile"),
  updateProfile: (data) =>
    api.put("/auth/profile", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  changePassword: (passwordData) => api.put("/auth/change-password", passwordData),
  updateLocation: (location) => api.put("/auth/location", location),
  updateSecuritySettings: (settings) => api.put("/auth/security-settings", settings),
  getAccountActivity: () => api.get("/auth/account-activity"),
  enable2FA: () => api.post("/auth/enable-2fa"),
  disable2FA: (code) => api.post("/auth/disable-2fa", { code }),
  verify2FA: (code) => api.post("/auth/verify-2fa", { code }),
};

export const booksAPI = {
  getAll: (params) => api.get("/books", { params }),
  getById: (id) => api.get(`/books/${id}`),
  getAllBooks: () => api.get("/books"),
  create: (formData) =>
    api.post("/books", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  update: (id, formData) =>
    api.put(`/books/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  delete: (id) => api.delete(`/books/${id}`),
  getMyBooks: () => api.get("/books/my-books"),
  getUserBooks: (userId) => api.get(`/books/user/${userId}`),
  // Advanced search endpoints
  searchByISBN: (isbn) => api.get(`/books/search/isbn/${isbn}`).then(res => res.data),
  getSuggestions: (params) => api.get("/books/suggestions", { params }).then(res => res.data),
  getRecommendations: (params) => api.get("/books/recommendations", { params }).then(res => res.data),
  getTrending: (params) => api.get("/books/trending", { params }).then(res => res.data),
  getFilterOptions: () => api.get("/books/filters"),
  getEnhancedFilters: () => api.get("/books/enhanced-filters").then(res => res.data),
  getBooksForSale: (params) => api.get("/books/for-sale", { params }).then(res => res.data),
  validatePrice: (data) => api.post("/books/validate-price", data).then(res => res.data),
};

export const bookSearchAPI = {
  searchBooks: (query, limit = 10) => api.get(`/book-search/search?q=${encodeURIComponent(query)}&limit=${limit}`).then(res => res.data),
  searchByISBN: (isbn) => api.get(`/book-search/search/isbn/${isbn}`).then(res => res.data),
  getBookCovers: (bookData) => api.post('/book-search/covers', bookData).then(res => res.data),
  validateImage: (url) => api.post('/book-search/validate-image', { url }).then(res => res.data),
  getExternalBookDetails: (source, id) => api.get(`/book-search/external/${source}/${id}`).then(res => res.data),
};

export const borrowAPI = {
  createRequest: (bookId) => api.post(`/borrow/request/${bookId}`),
  getMyRequests: () => api.get("/borrow/my-requests"),
  getReceivedRequests: () => api.get("/borrow/received-requests"),
  getAllBorrowRequests: () => api.get("/borrow/all-requests"),
  getBookHistory: () => api.get("/borrow/history"),
  updateRequest: (requestId, status) =>
    api.put(`/borrow/${requestId}`, { status }),
  deleteRequest: (requestId) => api.delete(`/borrow/${requestId}`),
  returnBook: (requestId) => api.put(`/borrow/${requestId}/return`),
  markAsBorrowed: (requestId) => api.put(`/borrow/${requestId}/borrowed`),
  markAsReturned: (requestId) => api.put(`/borrow/${requestId}/returned`),
};

export const usersAPI = {
  getUsersWithBooks: (params) => api.get("/users/with-books", { params }),
  getUserLocation: (userId) => api.get(`/users/${userId}/location`),
  getUserProfile: (userId) => api.get(`/users/${userId}/profile`),
  searchUsers: (params) => api.get("/users/search", { params }),
  updatePublicKey: (publicKeyJwk) =>
    api.put("/users/public-key", { publicKeyJwk }),
  // Wishlist endpoints
  addToWishlist: (bookId) => api.post(`/users/wishlist/${bookId}`).then(res => res.data),
  removeFromWishlist: (bookId) => api.delete(`/users/wishlist/${bookId}`).then(res => res.data),
  getWishlist: (params) => api.get("/users/wishlist", { params }).then(res => res.data),
  // Recently viewed endpoints
  getRecentlyViewed: (params) => api.get("/users/recently-viewed", { params }).then(res => res.data),
  addToRecentlyViewed: (bookId) => api.post(`/users/recently-viewed/${bookId}`).then(res => res.data),
  // Reading preferences endpoints
  getReadingPreferences: () => api.get("/users/reading-preferences").then(res => res.data),
  updateReadingPreferences: (preferences) => api.put("/users/reading-preferences", preferences).then(res => res.data),
  // User statistics endpoints
  getUserStatistics: () => api.get("/users/statistics").then(res => res.data),
  // Account deletion endpoints
  getDeletionPreview: () => api.get("/users/account/deletion-preview"),
  deleteAccount: (data) => api.delete("/users/account", { data }),
  // Mock online locations for globe
  getMockOnlineLocations: () => api.get("/users/mock-online-locations").then(res => res.data),
};

export const friendsAPI = {
  sendRequest: (userId) => api.post(`/friends/request/${userId}`),
  getAll: () => api.get("/friends"),
  respond: (id, action) => api.put(`/friends/request/${id}`, { action }),
  remove: (id) => api.delete(`/friends/${id}`),
  cancelRequest: (id) => api.delete(`/friends/${id}`),
};

export const messagesAPI = {
  sendMessage: (recipientId, data) => api.post(`/messages/send/${recipientId}`, data),
  sendFile: (recipientId, formData) => api.post(`/messages/send-file/${recipientId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  getConversations: (params) => api.get('/messages/conversations', { params }),
  getConversationWith: (userId) => api.get(`/messages/with/${userId}`),
  clearConversation: (conversationId) => api.delete(`/messages/conversation/${conversationId}`),
  blockUser: (userId) => api.post(`/messages/block/${userId}`),
  unblockUser: (userId) => api.post(`/messages/unblock/${userId}`),
  getBlockedUsers: () => api.get('/messages/blocked'),
  addReaction: (messageId, emoji) => api.post(`/messages/${messageId}/react`, { emoji }),
};

export const reportAPI = {
  createReport: (reportData) => api.post("/reports", reportData),
  getMyReports: () => api.get("/reports/my-reports"),
};



export const testimonialAPI = {
  createTestimonial: (testimonialData) =>
    api.post("/testimonials", testimonialData).then(res => res.data),
  getPublishedTestimonials: () => api.get("/testimonials").then(res => res.data),
  getUserTestimonial: () => api.get("/testimonials/my-testimonial").then(res => res.data),
  updateUserTestimonial: (testimonialData) =>
    api.put("/testimonials/my-testimonial", testimonialData).then(res => res.data),
  deleteUserTestimonial: () => api.delete("/testimonials/my-testimonial").then(res => res.data),
};

export const reviewsAPI = {
  create: (payload) => api.post("/reviews", payload),
  listForUser: (userId, params) =>
    api.get(`/reviews/user/${userId}`, { params }),
  summaryForUser: (userId) => api.get(`/reviews/user/${userId}/summary`),
  likeReview: (reviewId) => api.post(`/reviews/${reviewId}/like`),
  addComment: (reviewId, text) => api.post(`/reviews/${reviewId}/comment`, { text }),
  deleteComment: (reviewId, commentId) => api.delete(`/reviews/${reviewId}/comment/${commentId}`),
  // Admin endpoints
  getAllReviews: (params) => api.get('/reviews/admin/all', { params }),
  getReviewStats: () => api.get('/reviews/admin/stats'),
  deleteReview: (reviewId) => api.delete(`/reviews/admin/${reviewId}`),
};

export const notificationsAPI = {
  getUnreadCount: () => api.get('/notifications/count').then(res => res.data?.data || res.data),
  getAll: (params) => api.get('/notifications', { params }).then(res => res.data?.data || res.data),
  markRead: () => api.put('/notifications/mark-read').then(res => res.data),
  markAsRead: (notificationIds) => api.put('/notifications/mark-read', { notificationIds }).then(res => res.data),
  markAllAsRead: () => api.put('/notifications/mark-all-read').then(res => res.data),
  getModerationNotifications: () => api.get('/notifications/moderation').then(res => res.data?.data || res.data),
  createBookInquiry: ({ toUserId, subject, body }) => api.post('/notifications/book-inquiry', { toUserId, subject, body }).then(res => res.data),
  listBookInquiries: (params) => api.get('/notifications/book-inquiry', { params }).then(res => res.data?.data || res.data),

  delete: (id) => api.delete(`/notifications/${id}`).then(res => res.data),
  // New notification endpoints
  getNotificationsByType: (type, params) => api.get(`/notifications/type/${type}`, { params }).then(res => res.data?.data || res.data),
  getNotificationStats: () => api.get('/notifications/stats').then(res => res.data?.data || res.data),
  clearReadNotifications: () => api.delete('/notifications/clear-read').then(res => res.data),
  updatePreferences: (preferences) => api.put('/notifications/preferences', { preferences }).then(res => res.data),
};

export const contactAPI = {
  submitContactForm: (contactData) => api.post('/contact', contactData).then(res => res.data),
};

export const paymentAPI = {
  createVerificationOrder: () => api.post('/payment/create-verification-order'),
  verifyPayment: (paymentData) => api.post('/payment/verify-payment', paymentData),
  getVerificationStatus: () => api.get('/payment/verification-status'),
};

// Events API
export const eventsAPI = {
  // Public endpoints
  getPublicEvents: (params) => api.get('/events', { params }).then(res => res.data),
  getEventById: (id) => api.get(`/events/${id}`).then(res => res.data),
  registerForEvent: (id, data) => api.post(`/events/${id}/register`, data).then(res => res.data),
  cancelRegistration: (id) => api.delete(`/events/${id}/register`).then(res => res.data),
  getMyRegistrations: () => api.get('/events/my-registrations').then(res => res.data),
  
  // Admin endpoints
  getAllEventsAdmin: (params) => api.get('/events/admin/all', { params }).then(res => res.data),
  cancelEvent: (id, reason) => api.put(`/events/${id}/cancel`, { reason }).then(res => res.data),
  deleteEvent: (id) => api.delete(`/events/${id}`).then(res => res.data),
};

// Organizer API
export const organizerAPI = {
  // Application
  applyAsOrganizer: (data) => api.post('/organizer/apply', data).then(res => res.data),
  
  // Events management
  getOrganizerEvents: (params) => api.get('/organizer/events', { params }).then(res => res.data),
  getOrganizerEventsForMap: () => api.get('/organizer/events/map').then(res => res.data),
  createEvent: (data) => api.post('/organizer/events', data).then(res => res.data),
  updateEvent: (id, data) => api.put(`/organizer/events/${id}`, data).then(res => res.data),
  deleteEvent: (id) => api.delete(`/organizer/events/${id}`).then(res => res.data),
  
  // Registrants management
  getEventRegistrants: (id, params) => api.get(`/organizer/events/${id}/registrants`, { params }).then(res => res.data),
  exportRegistrants: (id) => api.get(`/organizer/events/${id}/export`, { responseType: 'blob' }),
  updateRegistrantStatus: (eventId, registrationId, data) => 
    api.put(`/organizer/events/${eventId}/registrants/${registrationId}`, data).then(res => res.data),
  
  // Stats
  getOrganizerStats: () => api.get('/organizer/stats').then(res => res.data),
  
  // Admin endpoints for organizer applications
  getApplications: (params) => api.get('/organizer/applications', { params }).then(res => res.data),
  approveApplication: (id) => api.put(`/organizer/applications/${id}/approve`).then(res => res.data),
  rejectApplication: (id, reason) => api.put(`/organizer/applications/${id}/reject`, { reason }).then(res => res.data),
};

export default api;
